import { EnvironmentService } from '../environment-service/environment.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../environment-service/environment.service";
var AgentCapabilityService = /** @class */ (function () {
    function AgentCapabilityService(http, environmentService) {
        this.http = http;
        this.environmentService = environmentService;
    }
    AgentCapabilityService.prototype.getCapabilities = function () {
        var url = this.environmentService.getApiRoot() + "vsts/agent-capabilities";
        return this.http.get(url);
    };
    AgentCapabilityService.ngInjectableDef = i0.defineInjectable({ factory: function AgentCapabilityService_Factory() { return new AgentCapabilityService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService)); }, token: AgentCapabilityService, providedIn: "root" });
    return AgentCapabilityService;
}());
export { AgentCapabilityService };
